import { Amplify } from 'aws-amplify';
import { fetchAuthSession } from 'aws-amplify/auth';
import { appConfig } from '../config';

// Configure Amplify Auth (v6) against the deployment's Cognito User Pool.
// Amplify persists tokens and handles refresh automatically; we only read the
// current session's JWT when we need it for AppSync requests.
export function configureAmplify(): void {
  Amplify.configure({
    Auth: {
      Cognito: {
        userPoolId: appConfig.userPoolId,
        userPoolClientId: appConfig.userPoolClientId,
      },
    },
  });
}

// Return the current Cognito access token (JWT), refreshing it if Amplify
// determines it is expired. Returns undefined when there is no signed-in user.
export async function getAuthToken(): Promise<string | undefined> {
  try {
    // `forceRefresh` is omitted: Amplify refreshes automatically when the
    // cached token is expired but the refresh token is still valid.
    const session = await fetchAuthSession();
    return session.tokens?.accessToken?.toString();
  } catch {
    return undefined;
  }
}
